import { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
export const Mycontext = createContext();

const Context = ({ children }) => {
    const navigate = useNavigate();
    const [user, setuser] = useState([]);
    const [refresh, setrefresh] = useState(true);
    const [AllNotesArray, setAllNotesArray] = useState([]);

    const [UpdateModalcontent, setUpdateModalcontent] = useState("");
    const [UpdateModalTitle, setUpdateModalTitle] = useState("");
    const [DeleteModalTitle, setDeleteModalTitle] = useState("");
    const [NoteId, setNoteId] = useState("");

    const [searchNoteArray, setsearchNoteArray] = useState([]);
    const [SearchKeyword, setSearchKeyword] = useState("");

    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        setuser(userInfo);
        if (!userInfo) {
            navigate("/")
        }
    }, [navigate])

    const value = {
        user, setuser, refresh, setrefresh, AllNotesArray, setAllNotesArray,
        UpdateModalcontent, setUpdateModalcontent,
        UpdateModalTitle, setUpdateModalTitle,
        NoteId, setNoteId, DeleteModalTitle, setDeleteModalTitle
        , searchNoteArray, setsearchNoteArray, SearchKeyword, setSearchKeyword
    };

    return (
        <Mycontext.Provider value={value}>
            {children}
        </Mycontext.Provider>
    )

}

const useGlobalContext = () => {
    return useContext(Mycontext);
}

export default Context
export { useGlobalContext }


